export class StoryData {
  timer?: string; // see time-utils for timecode format (ex: '0:03:00.000')
  dialogIntroId: string;
  dialog: Exchange[];

  constructor(elem?: StoryData) {
    this.timer = elem?.timer ?? null;
    this.dialogIntroId = elem?.dialogIntroId ?? null;
    this.dialog = elem?.dialog?.map(d => new Exchange(d)) ?? null;
  }
}

export class Exchange {
  id: string;
  commercialSentence: string; // markdown
  customerAnswer?: string; // markdown
  possibleAnswers?: string[]; // array of exchange ids
  succeed?: boolean;
  conclusion?: string;

  constructor(elem?: Exchange) {
    this.id = elem?.id ?? null;
    this.commercialSentence = elem?.commercialSentence ?? null;
    this.customerAnswer = elem?.customerAnswer ?? null;
    this.possibleAnswers = elem?.possibleAnswers ?? null;
    this.succeed = elem?.succeed ?? false;
    this.conclusion = elem?.conclusion ?? null;
  }
}
